module.exports = __webpack_public_path__ + "static/barr-f7255c4198e307b39b5c17cba91d5650.pdf";